var icon = require('vue-svgicon')
icon.register({
  'ks-icon-collapse-all': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M88.48 116.79L64 92.31l-24.48 24.48-7.52-7.58 32-32 32 32zM29 69v-9.86h69V69zM39.52 11.21L64 35.69l24.48-24.48L96 18.79l-32 32-32-32z"/>'
  }
})
